"use strict";

module.exports = {
  strings: {
    pluginNameFacebook: 'Facebook'
  }
};